/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DownloadAction/view.blocks to change it.
import LinkButtonGrey from 'DesignSystem/LinkButtonGrey/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DownloadAction({
  children,
  viewPath = "/DesignSystem/CommsThreadEventAttachments/Content/Attachment/ImageAttachment/PreviewAttachment/Content/DownloadAction",
  value
  
}) {
  return (<React.Fragment
>
<LinkButtonGrey
  viewPath={`${viewPath}/LinkButtonGrey`}
 text="Download"
 goTo={value}
/>
{children}
</React.Fragment>)
}